export const corporation = {
  corporationName: {
    title: 'Corporation name',
    type: 'simple-text',
    value: ''
  },
  contactPerson: {
    title: 'Corporation contact person',
    type: 'simple-text',
    value: ''
  },
  corporationPhoneWork: {
    title: 'Corporation phone work',
    type: 'phone',
    value: ''
  },
  corporationPhoneMobile: {
    title: 'Corporation phone mobile',
    type: 'mobile',
    value: ''
  },
  corporationEmailPrimary: {
    title: 'Corporation email primary',
    type: 'email',
    value: ''
  },
  corporationEmailAlternative: {
    title: 'Corporation email alternative',
    type: 'email',
    value: ''
  },
  headOfficeAddress: {
    title: 'Owners corporation head office address',
    type: 'address',
    value: ''
  },
  managementPSNumber: {
    title: 'Owners corporation management PS number',
    type: 'simple-text',
    value: ''
  }
}
